export const zIndex = {
    base: 1000000,
    alwaysVisible: 1000001,
    aboveBookingWidget: 1000002,
    pageLevel: 1,
};
